import { useForm, useWatch } from "react-hook-form";
import { ModalReabrirCriativoStyled } from "./style";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { ReactSVG } from "react-svg";
import UploadSvg from "../../../assets/upload.svg";
import { useAuth } from "../../../providers/Auth";


export const ModalNotaFornecedor = ({ orcamento, setOrcamento, buscarMaterialBriefing }) => {
  const { handleSubmit, register, watch, control, setValue } = useForm()
  const { user } = useAuth();

  let arquivo = useWatch({
    control,
    name: `nf_fornecedor`,
  });

  function onSubmitFunction() {

    if (!arquivo || arquivo?.length === 0) {
      return toast.error("Por favor, selecione um arquivo para enviar.");
    }
    const formData = new FormData();
    for (const anexo of arquivo) {
      formData.append(`nf_fornecedor`, anexo);
    }

    api.patch(
      `/orcamento-materiais-briefing/anexo/${orcamento.id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then(() => {
        toast.success("Arquivo enviado com sucesso!");
        buscarMaterialBriefing();
        setOrcamento(null);
        return;
      }
      ).catch((error) => {
        console.error("Erro ao enviar arquivo:", error);
        toast.error("Erro ao enviar arquivo. Tente novamente.");
        return;
      }
      );
  }

  return (
    <ModalReabrirCriativoStyled >
      <form className="div-body" onSubmit={handleSubmit(onSubmitFunction)}>
        <span onClick={() => setOrcamento(null)} className="close">
          X
        </span>
        <h2>Selecione outro anexo para substituir</h2>
        <h3></h3>
        <div>
          <div className="upload">
            <span>Atual: </span>
            <a href={orcamento.nf_fornecedor} target="_blank">
              Nota Fiscal
            </a>
          </div>
          {arquivo?.[0] ? (
            <div className="upload flex">
              <span>Novo: {" "}</span>
              <div className="relative">
                <a href={URL.createObjectURL(arquivo[0])} target="_blank">
                  {arquivo[0].name.slice(0, 15)}...
                </a>
                <span className="remove-file" onClick={() => {
                  setValue(`nf_fornecedor`, null)
                }}>X</span>
              </div>
            </div>
          ) : (
            <div className="flex">
              <span>Novo: </span>
              <label className="label-file" htmlFor={`nf_fornecedor`}>
                Escolher arquivo
                <ReactSVG src={UploadSvg} />
              </label>
              <div className="relative">
                <input
                  hidden
                  type="file"
                  id={`nf_fornecedor`}
                  {...register(`nf_fornecedor`)}
                />
              </div>
            </div>
          )}
          <div className="buttons">
            <button className="salvar" hidden={!user.permissoes.includes("admin")}>Salvar</button>
          </div>
        </div>
      </form>
    </ModalReabrirCriativoStyled>
  );
};